import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys } from 'src/utils';
import { requestCCApi } from 'src/utils/axios-utils';

interface BulkReplaceComponentRequest {
  id: number;
  component_id: number;
  narrative: string;
}

type BulkReplaceComponentData = BulkReplaceComponentRequest[];

const saveBulkReplaceComponent = async (data: BulkReplaceComponentData) => {
  return requestCCApi({
    url: '/bulkReplaceComponentSchedules',
    method: 'POST',
    data,
  });
};

export const useSaveBulkReplaceComponent = () => {
  return useMutation({
    mutationFn: saveBulkReplaceComponent,
    onSuccess: () => {
      queryClient.invalidateQueries(
        queryKeys.getCalendarSidebarDetails.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.components.invalidateAll());
    },
  });
};
